export enum AssessorsPropertyTypeEnum {
  Commercial = 1,
  Industrial = 2,
  LandFarm = 3,
  Residential = 4,
}
